/* GBI · collection head (owner K1). Spec: docs/specs/gbi-collection-spec.md §4.6
   1. Rail: the current tile is scrolled into view on load (horizontal only, no animation, no page scroll).
   2. Hero video: no download on Save-Data / 2G (poster stays, toggle hidden).
   Speed audit #2 (2026-10-13): the rev 2 "hold the <source>s back until window load + idle" step is gone. It
   never took effect (the browser had already picked the source, so the currentSrc check returned at once),
   and the clip now starts as soon as its poster has loaded, from the small inline script that
   snippets/gbi-home-hero-video.liquid prints after each player (same as the homepage hero).
   Clicks are tracked by gbi-home.js ([data-gbi-track="subcollection_click"] + data-gbi-t-from/to/pos).
   The video itself runs on <gbi-build-video> (gbi-pdp-sections.js), the fade-in on gbi-home.js.
   Vanilla ES2019, one IIFE, run-once flag. Re-inits on shopify:section:load. */
(function () {
  'use strict';
  if (window.__gbiCHead) return;
  window.__gbiCHead = true;

  var doc = document;

  function revealCurrent(root) {
    var track = root.querySelector('.gbi-cnav__track');
    var cur = track && track.querySelector('[aria-current="page"]');
    if (!track || !cur) return;
    var item = cur.closest('.gbi-cnav__item') || cur;
    var cs = getComputedStyle(track);
    var pad = parseFloat(cs.scrollPaddingLeft) || parseFloat(cs.paddingLeft) || 0;
    var x0 = item.offsetLeft;                       // the track is position:relative (gbi-pdp-sections.css)
    var x1 = x0 + item.offsetWidth;
    var v0 = track.scrollLeft;
    var v1 = v0 + track.clientWidth;
    var shown = Math.min(x1, v1) - Math.max(x0, v0);
    // Only when less than 60 % of the tile shows: the family's first tiles stay in view when possible.
    if (shown < item.offsetWidth * 0.6) {
      track.scrollLeft = Math.max(0, x0 - pad);   // snap lands the tile at the gutter, previous tile peeking
    }
  }

  function saveData() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }

  function guardVideo(root) {
    if (!saveData()) return;
    Array.prototype.forEach.call(root.querySelectorAll('.gbi-chero video'), function (v) {
      Array.prototype.forEach.call(v.querySelectorAll('source'), function (s) { s.remove(); });
      v.removeAttribute('src');
      try { v.load(); } catch (e) { /* noop */ }
      var t = v.parentNode && v.parentNode.querySelector('[data-gbi-build-toggle]');
      if (t) t.hidden = true;
    });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || doc).querySelectorAll('[data-gbi-chead]'), function (root) {
      guardVideo(root);
      // after layout (fonts can change tile widths)
      requestAnimationFrame(function () { revealCurrent(root); });
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { revealCurrent(root); });
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
